import { createSlice } from "redux-starter-kit";


const shippingAndReturnsOverlay = createSlice({
    slice: "shippingAndReturnsOverlay",
    initialState: { open: false, linkId: null },
    reducers: {
        openShippingAndReturnsOverlay(state, action) {
            state.open = true;
            state.linkId = action.payload;
        },

        closeShippingAndReturnsOverlay(state) {
            state.open = false;
            state.linkId = null;
        },
    },
});

const { actions, reducer } = shippingAndReturnsOverlay;
export const { openShippingAndReturnsOverlay, closeShippingAndReturnsOverlay } = actions;
export default reducer;
